import { styled } from 'solid-styled-components';
import { LoaderIcon } from 'src/app/components';

export const LoaderIconStyled = styled(LoaderIcon)`
    align-self: center;
`;
